import useModalStore, {
  ModalNames,
} from 'features/stream/ModalError/stores/useGlobalStreamError';
import ERROR_MESSAGE from 'constants/errorMessage';
import handleErrorMessageAPI from 'global/AlertErrorMessage';

interface ErrorResponse {
  message: string;
  status: number;
  errorType: string;
  errors: Array<{
    key: string;
    error: string;
  }>;
}

const checkErrorPostLink = (error: { cause: ErrorResponse }): boolean => {
  const errorComposeLink = (error?.cause?.errors || [])?.find(
    (err: { key: string; error: string }) => err.key === 'LINK',
  );
  return (
    error?.cause?.status === 400 &&
    error?.cause?.errorType === 'INVALID_PARAMETER' &&
    !!errorComposeLink
  );
};

export const handleErrorPostStream = (
  error: {
    cause: ErrorResponse;
  },
  type?: string,
): void => {
  if (!error) {
    return;
  }
  if (
    error.cause.errorType === 'POST_REACHED_LIMIT' ||
    error.cause.errorType === 'POST_IS_NOT_ALLOWED'
  ) {
    useModalStore
      .getState()
      .openModal(ModalNames.STREAM_POST_LIMIT, error.cause.message, type ?? '');
  } else if (checkErrorPostLink(error)) {
    useModalStore.getState().openModal(ModalNames.COMPOSE_ERROR_LINK);
  } else {
    handleErrorMessageAPI(error?.cause?.message, ERROR_MESSAGE.ALERT_RED);
  }
};
